export const LicensesStore = {
    namespaced: true,
    state: {
        licenses: [],
        license: {}
    },
    mutations:{
        setLicenses(state: any, response: any) {
            state.licenses = response;
        },
        setLicense(state: any, response: any) {
            state.license = response;
        }
    },
    actions:{
        setLicenses(context: any, response: any) {
            context.commit('setLicenses', response);
        },
        setLicense(context: any, response: any) {
            context.commit('setLicense', response);
        }
    },
    getters: {
        getLicenses: (state: any) => state.licenses,
        getLicense: (state: any) => state.license
    }
}